// ---------------PRODUCT CARDS ----------------

(function () {
    var wrappers = Array.from(document.querySelectorAll('.kairaus-product-tab-wrapper'));
    if (!wrappers.length) return;

    wrappers.forEach(function (wrapper) {
        var tabs = Array.from(wrapper.querySelectorAll('.tab'));
        var tabContents = Array.from(wrapper.querySelectorAll('.tab-content'));
        if (!tabs.length) return;

        tabs.forEach(function (tab) {
            tab.addEventListener('click', function () {
                tabs.forEach(function (t) { t.classList.remove('active'); });
                tabContents.forEach(function (c) { c.classList.remove('active'); });
                tab.classList.add('active');
                var target = wrapper.querySelector('#' + CSS.escape(tab.dataset.tab));
                if (target) target.classList.add('active');
            });
        });
    });
})();

// --------------------------------------------------------------------------




// ----------------CARD WRAPPER-----------------

window.addEventListener('load', function () {
    document.querySelectorAll('.card-wrapper').forEach(function (cardEl) {
        if (cardEl.swiper) { cardEl.swiper.update(); return; }

        // Swiper requires CSS selector strings (not DOM elements) for pagination/navigation
        var paginationEl = cardEl.querySelector('.swiper-pagination');
        var nextEl       = cardEl.querySelector('.custom-next');
        var prevEl       = cardEl.querySelector('.custom-prev');

        var config = {
            loop: true,
            speed: 900,
            spaceBetween: 24,
            autoplay: { delay: 2500, disableOnInteraction: false },
            breakpoints: {
                0:    { slidesPerView: 1.15, spaceBetween: 12 },
                360:  { slidesPerView: 1.4,  spaceBetween: 14 },
                480:  { slidesPerView: 1.6,  spaceBetween: 14 },
                577:  { slidesPerView: 2.2,  spaceBetween: 16 },
                768:  { slidesPerView: 2.5,  spaceBetween: 18 },
                1024: { slidesPerView: 3.5,  spaceBetween: 20 },
                1440: { slidesPerView: 4,    spaceBetween: 24 },
                1920: { slidesPerView: 4,    spaceBetween: 28 },
                2560: { slidesPerView: 4.35, spaceBetween: 32 },
            }
        };

        // Only add pagination if the element exists
        if (paginationEl) {
            config.pagination = { el: paginationEl, clickable: true };
        }

        // Only add navigation if both buttons exist
        if (nextEl && prevEl) {
            config.navigation = { nextEl: nextEl, prevEl: prevEl };
        }

        new Swiper(cardEl, config);
    });
});
// -------------------------------------------------------------------------




// ------------------BROWSE MOTION SLIDER------------------

window.addEventListener('load', function () {
    document.querySelectorAll('.browse-motion__slider').forEach(function (browseEl) {
        if (browseEl.swiper) { browseEl.swiper.update(); return; }

        // Use CSS string selectors — always safe regardless of DOM presence
        new Swiper(browseEl, {
            slidesPerView: 3,
            spaceBetween: 24,
            speed: 900,
            loop: true,
            allowTouchMove: true,
            autoplay: { delay: 2500, disableOnInteraction: false },
            navigation: {
                nextEl: '.browse-motion__arrow--next',
                prevEl: '.browse-motion__arrow--prev',
            },
            breakpoints: {
                0:    { slidesPerView: 1.15, spaceBetween: 12 },
                481:  { slidesPerView: 2,    spaceBetween: 14 },
                768:  { slidesPerView: 2.4,  spaceBetween: 16 },
                1024: { slidesPerView: 3,    spaceBetween: 24 },
            }
        });
    });
});

// ------------------------------------------------------------------------------




// -------------------TESTIMONIALS AUTO SCROLL------------------

document.addEventListener('DOMContentLoaded', function () {
    var SPEED = 0.45;

    function setupColumn(col, direction) {
        var track = col.querySelector('.track');
        if (!track) return;

        var rafId = null;
        var y = 0;

        function gap() { return parseFloat(getComputedStyle(track).gap) || 0; }
        function itemFullHeight(el) { return el.offsetHeight + gap(); }

        function fillEnough() {
            var originals = Array.from(track.children);
            var safety = 0;
            while (track.scrollHeight < col.offsetHeight * 2 && safety < 20) {
                originals.forEach(function (card) {
                    var clone = card.cloneNode(true);
                    clone.setAttribute('aria-hidden', 'true');
                    track.appendChild(clone);
                });
                safety++;
            }
        }

        fillEnough();

        if (direction === 'down') {
            var last = track.lastElementChild;
            if (last) {
                track.insertBefore(last, track.firstElementChild);
                y = -itemFullHeight(last);
                track.style.transform = 'translate3d(0, ' + y + 'px, 0)';
            }
        } else {
            track.style.transform = 'translate3d(0, 0, 0)';
        }

        function animate() {
            if (direction === 'up') {
                y -= SPEED;
                var first = track.firstElementChild;
                if (first) {
                    var firstH = itemFullHeight(first);
                    if (Math.abs(y) >= firstH) { y += firstH; track.appendChild(first); }
                }
            } else {
                y += SPEED;
                if (y >= 0) {
                    var last = track.lastElementChild;
                    if (last) {
                        var lastH = itemFullHeight(last);
                        track.insertBefore(last, track.firstElementChild);
                        y -= lastH;
                    }
                }
            }
            track.style.transform = 'translate3d(0, ' + y + 'px, 0)';
            rafId = requestAnimationFrame(animate);
        }

        animate();
    }

    function initTestimonials() {
        var upCol   = document.querySelector('.col-up');
        var downCol = document.querySelector('.col-down');
        if (upCol)   setupColumn(upCol, 'up');
        if (downCol) setupColumn(downCol, 'down');
    }

    // Run after full page load so images/fonts don't affect column heights
    if (document.readyState === 'complete') {
        initTestimonials();
    } else {
        window.addEventListener('load', initTestimonials);
    }
});

// ---------------------------------------------------------------------




// -------------------TESTIMONIALS MOBILE AUTO SCROLL------------------

(function () {
    document.querySelectorAll('.testimonial-section').forEach(function (section) {
        var currentAvatar = section.querySelector('.testimonial-mobile__avatar--current');
        var nextAvatar    = section.querySelector('.testimonial-mobile__avatar--next');
        var quoteEl       = section.querySelector('#tmQuote');
        var nameEl        = section.querySelector('#tmName');
        var contentWrap   = section.querySelector('.testimonial-mobile__content');
        var dataScript    = section.querySelector('[id^="KairausTestimonialsMobileData-"]');
        var curveEl       = section.querySelector('.testimonial-mobile__curve');

        if (!quoteEl || !nameEl || !contentWrap || !dataScript || !curveEl) return;

        var testimonialData = [];
        try {
            testimonialData = JSON.parse(dataScript.textContent || '[]');
        } catch (error) {
            console.error('Invalid mobile testimonial JSON', error);
            return;
        }

        if (!Array.isArray(testimonialData) || testimonialData.length === 0) return;

        function ensureBackgroundColumns() {
            var bgLayer = section.querySelector('.testimonial-mobile__bg-layer');
            var bgCenter = section.querySelector('.testimonial-mobile__bg-center');
            if (!bgLayer || !bgCenter) return;

            var centerCard = bgCenter.querySelector('.testimonial-mobile__bg-card');
            if (!centerCard) return;

            function buildColumn(className) {
                var column = section.querySelector('.' + className);
                if (!column) {
                    column = document.createElement('div');
                    column.className = className;
                    bgLayer.appendChild(column);
                }

                if (column.querySelector('.testimonial-mobile__bg-card')) return;

                for (var i = 0; i < 3; i += 1) {
                    column.appendChild(centerCard.cloneNode(true));
                }
            }

            buildColumn('testimonial-mobile__bg-left');
            buildColumn('testimonial-mobile__bg-right');
        }

        ensureBackgroundColumns();

        function ensureAvatarElement(className) {
            var el = section.querySelector('.' + className);
            if (el) return el;

            var img = document.createElement('img');
            img.className = 'testimonial-mobile__avatar ' + className;
            img.alt = 'testimonial user';
            curveEl.appendChild(img);
            return img;
        }

        currentAvatar = ensureAvatarElement('testimonial-mobile__avatar--current');
        nextAvatar = ensureAvatarElement('testimonial-mobile__avatar--next');

        var activeIndex = 0;
        var isAnimating = false;

        function formatNameHTML(item) {
            if (!item.role) return '<strong>' + item.name + '</strong>';
            return '<strong>' + item.name + '</strong> - ' + item.role;
        }

        function applyEntry(item) {
            quoteEl.textContent = item.quote || '';
            nameEl.innerHTML = formatNameHTML(item);
        }

        var firstItem = testimonialData[0];
        applyEntry(firstItem);
        if (currentAvatar && nextAvatar && firstItem.image) {
            currentAvatar.src = firstItem.image;
            nextAvatar.src = firstItem.image;
        }

        function resetAvatarState() {
            if (!currentAvatar || !nextAvatar) return;
            currentAvatar.classList.remove('is-exiting');
            nextAvatar.classList.remove('is-entering');
        }

        function changeTestimonial() {
            if (isAnimating || testimonialData.length < 2) return;
            isAnimating = true;

            var nextIndex = (activeIndex + 1) % testimonialData.length;
            var nextItem  = testimonialData[nextIndex];

            if (currentAvatar && nextAvatar && nextItem.image) {
                nextAvatar.src = nextItem.image;
            }

            resetAvatarState();
            if (currentAvatar && nextAvatar) {
                void currentAvatar.offsetWidth;
            }

            if (currentAvatar && nextAvatar) {
                currentAvatar.classList.add('is-exiting');
                nextAvatar.classList.add('is-entering');
            }
            contentWrap.classList.add('is-changing');

            setTimeout(function () {
                applyEntry(nextItem);
                contentWrap.classList.remove('is-changing');
            }, 320);

            setTimeout(function () {
                if (currentAvatar && nextAvatar && nextItem.image) {
                    currentAvatar.src = nextItem.image;
                }

                resetAvatarState();
                activeIndex = nextIndex;
                isAnimating = false;
            }, 800);
        }

        setInterval(changeTestimonial, 3000);
    });
})();

// ----------------------------------------------------------------------




// -------------------CONTACT STRIP MOBILE AUTO SCROLL------------------

(function () {
    document.querySelectorAll('.contact-strip-mobile__slider').forEach(function (el) {
        if (el.swiper) return;

        // Use CSS selector string for pagination — safe even if element not yet in DOM
        new Swiper(el, {
            slidesPerView: 1.1,
            spaceBetween: 16,
            loop: true,
            speed: 700,
            grabCursor: true,
            autoplay: { delay: 2500, disableOnInteraction: false },
            pagination: {
                el: '.contact-strip-mobile__pagination',
                clickable: true
            }
        });
    });
})();

// ----------------------------------------------------------------------




// ---------------------FEATURE SLIDER------------------

(function () {
    function startProgress(section, animationTime) {
        section.querySelectorAll('.progress').forEach(function (bar) {
            bar.style.animation = 'none';
            bar.style.transform = 'scaleX(0)';
        });
        var activeBar = section.querySelector('.swiper-pagination-bullet-active .progress');
        if (activeBar) {
            activeBar.offsetWidth; // force reflow
            activeBar.style.animation = 'slideDash ' + animationTime + 'ms linear forwards';
        }
    }

    function syncFeatureSlideVideos(section) {
        if (!section) return;

        var prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

        section.querySelectorAll('video').forEach(function (video) {
            video.pause();
        });

        if (prefersReducedMotion) return;

        var activeSlide = section.querySelector('.swiper-slide-active');
        if (!activeSlide) return;

        var activeVideo = activeSlide.querySelector('video');
        if (!activeVideo) return;

        activeVideo.currentTime = 0;
        var playPromise = activeVideo.play();
        if (playPromise && typeof playPromise.catch === 'function') {
            playPromise.catch(function () {});
        }
    }

    function initFeatureSliders() {
        var sections = document.querySelectorAll('.feature-slider');
        if (!sections.length) return;

        sections.forEach(function (section) {
            var swiperEl = section.querySelector('.swiper');
            if (!swiperEl) return;
            if (swiperEl.swiper) return; // already initialized

            // Read settings from data attributes set by Shopify theme editor
            var autoplayEnabled = section.dataset.autoplay === 'true';
            var autoplayDelay   = parseInt(section.dataset.autoplayDelay, 10) || 4000;
            var paginationEl    = section.querySelector('.feature-pagination');

            var swiperConfig = {
                loop: true,
                speed: 900,
                effect: 'fade',
                fadeEffect: { crossFade: true },
                on: {
                    init: function () {
                        startProgress(section, autoplayDelay);
                        syncFeatureSlideVideos(section);
                    },
                    slideChangeTransitionStart: function () {
                        startProgress(section, autoplayDelay);
                        syncFeatureSlideVideos(section);
                    }
                }
            };

            // Only add pagination if the element exists
            if (paginationEl) {
                swiperConfig.pagination = {
                    el: paginationEl,
                    clickable: true,
                    renderBullet: function (index, className) {
                        return '<span class="' + className + '"><span class="progress"></span></span>';
                    }
                };
            }

            // Only add autoplay if enabled in theme settings
            if (autoplayEnabled) {
                swiperConfig.autoplay = {
                    delay: autoplayDelay,
                    disableOnInteraction: false
                };
            }

            new Swiper(swiperEl, swiperConfig);
        });
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', initFeatureSliders);
    } else {
        initFeatureSliders();
    }
})();